module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return (_vm.visible) ? _vm._c('div', {
    staticClass: "gv-inverted-color-scheme",
    attrs: {
      "id": "gv-cultura-legend"
    }
  }, [_vm._c('div', {
    staticClass: "gv-cultura-legend-title gv-color-scheme",
    attrs: {
      "id": "gv-cultura-legend-title"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.title) + "\n    "), _vm._c('button', {
    class: _vm.toggleCollapseClass(),
    attrs: {
      "size": "mini",
      "title": "Nascondi Legenda"
    },
    on: {
      "click": _vm.hideLegend
    }
  })]), _vm._v(" "), _vm._c('div', {
    staticClass: "gv-cultura-legend-wrapper",
    attrs: {
      "id": "gv-cultura-legend-wrapper"
    }
  }, [_vm._c('div', [_vm._c('div', {
    staticClass: "gv-inverted-color-scheme",
    attrs: {
      "id": "gv-cultura-legend-body"
    }
  }, [_vm._c('gv-cultura-legend-maps', {
    attrs: {
      "options": _vm.options
    }
  })], 1)])])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-11d8b94a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CulturaLegend.vue
// module id = 822
// module chunks = 39